import React, { useState } from "react";
import { adminWallets } from "../../utils/config";
import { Link } from "gatsby";
import { useImx } from "../../contexts/ImxContext";
import { utils } from "ethers";
import AssetImage from "../AssetImage/AssetImage";
import EthereumAddress from "../EthereumAddress/EthereumAddress";
import useAssets from "../../hooks/useAssets";
import useCabbage from "../../hooks/useCabbage";

const Header = ({ submenu }) => {
  const {
    account,
    connectEthereum,
    actionHandler,
    disconnect,
    paymentAt,
    setPaymentAt,
    balance,
    impersonate,
    setImpersonate,
  } = useImx();
  const [navMobileShow, setNavMobileShow] = useState(false);
  const { cabbage, packedCabbage } = useCabbage();

  const originalBunnies = useAssets("original-bunny");
  const profileImage =
    originalBunnies && originalBunnies.length ? (
      <AssetImage asset={originalBunnies[0]} onlyImg={true} className="profile-img" alt="" />
    ) : (
      <img src="/assets/icons/profile.png" className="profile-img" alt="" />
    );

  const navItems = [
    {
      name: "PACKS",
      mobile: "MINT PACKS",
      to: "/mint",
      icon: "/assets/icons/shop.png",
    },
    {
      name: "CARDS",
      mobile: "CARDS",
      to: "/cards",
      icon: "/assets/icons/gem.png",
    },
    {
      name: "FARMS",
      mobile: "MINT FARMS",
      to: "/farm/mint",
      icon: "/assets/icons/shop.png",
    },
    {
      name: "BUNKS",
      mobile: "BUNKS",
      to: "/bunks",
      icon: "/assets/icons/gem.png",
    },
    {
      name: "TCG",
      mobile: "BUY TCG",
      to: "/tcg",
      icon: "/assets/icons/shop.png",
    },
    {
      name: "GAMEPLAY",
      mobile: "HOW TO PLAY",
      to: "/how-to",
      icon: "/assets/icons/settings.png",
    },
    {
      name: "MARKET",
      mobile: "MARKETPLACE",
      to: "/marketplace",
      icon: "/assets/icons/shop.png",
    },
    {
      name: "FUSE",
      mobile: "FUSE",
      to: account ? "/my/fuse/cards" : "/fuse",
      icon: "/assets/icons/star.png",
    },
    {
      name: "BATTLEPASS",
      mobile: "BATTLEPASS",
      to: "/battlepass",
      icon: "/assets/icons/star.png",
    },
    {
      name: "SHOP",
      mobile: "CABBAGE SHOP",
      to: "/cabbage-shop",
      icon: "/assets/icons/shop.png",
    },
    {
      mobile: "GANGS",
      to: "/gangs",
      icon: "/assets/icons/star.png",
    },
    {
      mobile: "MERCH",
      to: "https://pawwarztcg.myshopify.com/collections/bad-bunnies-paw-warz-season-01-collection",
      icon: "/assets/icons/hand.png",
    },
  ];

  return (
    <>
      <header className="header">
        {impersonate && (
          <div className="banner">
            You are impersonating <EthereumAddress account={impersonate} />
            <button
              className="button"
              onClick={() => setImpersonate(undefined)}
              style={{ padding: "4px", marginLeft: "8px" }}
            >
              End
            </button>
          </div>
        )}
        <nav>
          <div className="nav-main">
            <Link to="/" className="logo">
              <img src="/assets/icons/logo.png" alt="Bad bunnies logo" />
            </Link>
            <div className="logged-nav">
              {account ? (
                <Link to="/my/account" className="user">
                  {profileImage}
                </Link>
              ) : (
                <button onClick={connectEthereum} className="button outline">
                  CONNECT
                </button>
              )}
              <div className="nav-toggle" onClick={() => setNavMobileShow(!navMobileShow)}>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
          <div className="collapsible">
            <div>
              {navItems
                .filter((item) => item.name)
                .map((item, index) =>
                  item.to.startsWith("http") ? (
                    <a key={index} href={item.to} target="_blank" className="link">
                      {item.name}
                    </a>
                  ) : (
                    <Link key={index} to={item.to} className="link">
                      {item.name}
                    </Link>
                  )
                )}
            </div>
            {account ? (
              <div className="connected">
                <Link to="/my/packs" className="link">
                  MY PACKS
                </Link>
                <Link to="/my/cards" className="link">
                  MY CARDS
                </Link>
                <div className="user">
                  <div>
                    <p className="account">
                      <EthereumAddress account={account} />
                    </p>
                    <p>
                      <select onChange={(e) => setPaymentAt(e.target.value)} value={paymentAt} id="payment-at">
                        <option value="eth">Ethereum</option>
                        <option value="imx">Immutable</option>
                      </select>
                    </p>
                  </div>
                  <div>
                    <p>ETH</p>
                    <p>{balance ? utils.formatEther(balance).slice(0, 5).padEnd(5, "0") : "..."}</p>
                  </div>
                  <div>
                    <p>Cabbage</p>
                    <p>{cabbage + packedCabbage}</p>
                  </div>
                  <Link to="/my/account">{profileImage}</Link>
                  <div className="user-dropdown">
                    <div>
                      <Link to="/my/account" className="link">
                        <img src="/assets/icons/gem.png" alt="" />
                        MY ACCOUNT
                      </Link>
                      <Link to="/my/rewards" className="link">
                        <img src="/assets/icons/heart.png" style={{ width: "24px", height: "24px" }} alt="" />
                        MY REWARDS
                      </Link>
                      <Link to="/my/open-packs" className="link">
                        <img src="/assets/icons/hand.png" alt="" />
                        OPEN PACKS
                      </Link>
                      <Link to="/farm/overview" className="link">
                        <img src="/assets/icons/shop.png" alt="" />
                        FARMING
                      </Link>
                      <Link to="/my/fuse/cards" className="link">
                        <img src="/assets/icons/star.png" alt="" />
                        FUSE
                      </Link>
                      <Link to="/my/decks" className="link">
                        <img src="/assets/icons/hand.png" alt="" />
                        MY DECKS
                      </Link>
                      {adminWallets.includes(account) && (
                        <Link to="/bb-admin" className="link">
                          <img src="/assets/icons/settings.png" alt="" />
                          ADMIN
                        </Link>
                      )}
                      <button onClick={() => actionHandler(disconnect)} className="link">
                        <img src="/assets/icons/logout.png" alt="" />
                        DISCONNECT
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <button onClick={connectEthereum} className="button outline">
                  CONNECT WALLET
                </button>
              </div>
            )}
          </div>
        </nav>
        {submenu && <div className="submenu">{submenu}</div>}
      </header>
      <div className={navMobileShow ? "nav-mobile nav-mobile-show" : "nav-mobile"}>
        <nav>
          <div className="collapse-head">
            <h2>Menu</h2>
            <img src="/assets/icons/close.png" alt="" className="nav-hide" onClick={() => setNavMobileShow(false)} />
          </div>
          <div>
            {navItems
              .filter((item) => item.mobile)
              .map((item, index) =>
                item.to.startsWith("http") ? (
                  <a key={index} href={item.to} target="_blank" className="link">
                    <img src={item.icon} alt="" />
                    {item.mobile}
                  </a>
                ) : (
                  <Link key={index} to={item.to} className="link">
                    <img src={item.icon} alt="" />
                    {item.mobile}
                  </Link>
                )
              )}
            {account ? (
              <>
                <Link to="/my/account" className="link">
                  <img src="/assets/icons/star.png" alt="" />
                  MY ACCOUNT
                </Link>
                <Link to="/my/cards" className="link">
                  <img src="/assets/icons/star.png" alt="" />
                  MY COLLECTION
                </Link>
                <button onClick={() => actionHandler(disconnect)} className="link">
                  <img src="/assets/icons/logout.png" alt="" />
                  DISCONNECT
                </button>
              </>
            ) : (
              <button onClick={connectEthereum} className="link">
                <img src="/assets/icons/settings.png" alt="" />
                CONNECT WALLET
              </button>
            )}
          </div>
        </nav>
      </div>
    </>
  );
};

export default Header;
